import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpServiceProvider {

  URL_API = '50.114.32.141';

  constructor(public http: HttpClient) { }

  getDadosServidor(endpoint) {
    return this.http.get('http://' + this.URL_API + '/ateccardapioonline/response/listarInfo.php?url=' + endpoint);
  }

  get(endpoint) {
    return this.http.get('http://' + this.URL_API + '/ateccardapioonline/response/' + endpoint + '.php?bd=' + localStorage.getItem("database") + '&numFilial=' + localStorage.getItem("filial"));
  }

  post(body, headers) {
    return this.http.post('http://' + this.URL_API + '/ateccardapioonline/receive/inserirPedido.php?bd=' + localStorage.getItem("database") + '&numFilial=' + localStorage.getItem("filial"), body, headers)
  }
  getCep(cep) {
    return this.http.get("https://viacep.com.br/ws/" + cep + "/json/")
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-service/http-service.ts